import React, { Component } from 'react';
import { Button, Modal, Select } from 'antd';
import Language from '../../assets/Language.png';
import CancelIcon from '../../assets/cancelTop1.png';

class GoogleTranslator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      err: false,
      modalVisible: false,
      isScriptLoaded: false,
      selectedLanguage: 'en',
      tempSelectedLanguage: 'en',
    };
  }

  componentDidMount() {
    this.loadGoogleTranslateScript();
  }

  loadGoogleTranslateScript = () => {
    if (!document.querySelector('script[src*="translate.google.com"]')) {
      window.googleTranslateElementInit = () => {
        if (window.google && window.google.translate) {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: 'en',
              autoDisplay: false,
              layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL, // Changed to HORIZONTAL
            },
            'google_translate_element'
          );
          this.setState({ isScriptLoaded: true });
        }
      };

      const addScript = document.createElement('script');
      addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
      addScript.onerror = () => {
        this.setState({ err: true });
      };
      document.body.appendChild(addScript);
    } else if (window.google && window.google.translate) {
      this.googleTranslateElementInit();
    }
  };

  googleTranslateElementInit = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          autoDisplay: false,
          layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL,
        },
        'google_translate_element'
      );
      this.setState({ isScriptLoaded: true });
    }
  };

  handleLanguageChange = (value) => {
    this.setState({ tempSelectedLanguage: value });
  };

  handleSave = () => {
    const { tempSelectedLanguage } = this.state;
    this.setState({ selectedLanguage: tempSelectedLanguage });

    if (window.google && window.google.translate) {
      const select = document.querySelector('.goog-te-combo');
      if (select) {
        select.value = tempSelectedLanguage;
        select.dispatchEvent(new Event('change'));
      } else {
        console.warn('Google Translate combo box not found, attempting fallback');
        // Fallback: Use Google's translate method directly if available
        if (window.google.translate.TranslateElement) {
          const translator = new window.google.translate.TranslateElement();
          translator.translatePage(tempSelectedLanguage);
        }
      }
    }
    this.handleModalClose();
  };

  componentDidCatch(err) {
    console.log('Error caught in componentDidCatch:', err);
    this.setState({ err: true });
  }

  handleModalClose = () => {
    this.setState({
      modalVisible: false,
      tempSelectedLanguage: this.state.selectedLanguage,
    });
  };

  handleModalOpen = () => {
    this.setState({ modalVisible: true });
  };

  render() {
    const { modalVisible, err, tempSelectedLanguage, selectedLanguage } = this.state;

    const languages = [
      { value: 'en', label: 'English' },
      { value: 'af', label: 'Afrikaans' },
      { value: 'sq', label: 'Albanian' },
      { value: 'am', label: 'Amharic' },
      { value: 'ar', label: 'Arabic' },
      { value: 'hy', label: 'Armenian' },
      { value: 'az', label: 'Azerbaijani' },
      { value: 'eu', label: 'Basque' },
      { value: 'be', label: 'Belarusian' },
      { value: 'bn', label: 'Bengali' },
      { value: 'bs', label: 'Bosnian' },
      { value: 'bg', label: 'Bulgarian' },
      { value: 'ca', label: 'Catalan' },
      { value: 'ceb', label: 'Cebuano' },
      { value: 'zh', label: 'Chinese (Simplified)' },
      { value: 'zh-TW', label: 'Chinese (Traditional)' },
      { value: 'co', label: 'Corsican' },
      { value: 'hr', label: 'Croatian' },
      { value: 'cs', label: 'Czech' },
      { value: 'da', label: 'Danish' },
      { value: 'nl', label: 'Dutch' },
      { value: 'eo', label: 'Esperanto' },
      { value: 'et', label: 'Estonian' },
      { value: 'fi', label: 'Finnish' },
      { value: 'fr', label: 'French' },
      { value: 'fy', label: 'Frisian' },
      { value: 'gl', label: 'Galician' },
      { value: 'ka', label: 'Georgian' },
      { value: 'de', label: 'German' },
      { value: 'el', label: 'Greek' },
      { value: 'gu', label: 'Gujarati' },
      { value: 'ht', label: 'Haitian Creole' },
      { value: 'ha', label: 'Hausa' },
      { value: 'haw', label: 'Hawaiian' },
      { value: 'he', label: 'Hebrew' },
      { value: 'hi', label: 'Hindi' },
      { value: 'hmn', label: 'Hmong' },
      { value: 'hu', label: 'Hungarian' },
      { value: 'is', label: 'Icelandic' },
      { value: 'ig', label: 'Igbo' },
      { value: 'id', label: 'Indonesian' },
      { value: 'ga', label: 'Irish' },
      { value: 'it', label: 'Italian' },
      { value: 'ja', label: 'Japanese' },
      { value: 'jv', label: 'Javanese' },
      { value: 'kn', label: 'Kannada' },
      { value: 'kk', label: 'Kazakh' },
      { value: 'km', label: 'Khmer' },
      { value: 'ko', label: 'Korean' },
      { value: 'ku', label: 'Kurdish' },
      { value: 'ky', label: 'Kyrgyz' },
      { value: 'lo', label: 'Lao' },
      { value: 'la', label: 'Latin' },
      { value: 'lv', label: 'Latvian' },
      { value: 'lt', label: 'Lithuanian' },
      { value: 'lb', label: 'Luxembourgish' },
      { value: 'mk', label: 'Macedonian' },
      { value: 'mg', label: 'Malagasy' },
      { value: 'ms', label: 'Malay' },
      { value: 'ml', label: 'Malayalam' },
      { value: 'mt', label: 'Maltese' },
      { value: 'mi', label: 'Maori' },
      { value: 'mr', label: 'Marathi' },
      { value: 'mn', label: 'Mongolian' },
      { value: 'my', label: 'Myanmar (Burmese)' },
      { value: 'ne', label: 'Nepali' },
      { value: 'no', label: 'Norwegian' },
      { value: 'ny', label: 'Nyanja (Chichewa)' },
      { value: 'or', label: 'Odia (Oriya)' },
      { value: 'ps', label: 'Pashto' },
      { value: 'fa', label: 'Persian' },
      { value: 'pl', label: 'Polish' },
      { value: 'pt', label: 'Portuguese' },
      { value: 'pa', label: 'Punjabi' },
      { value: 'ro', label: 'Romanian' },
      { value: 'ru', label: 'Russian' },
      { value: 'sm', label: 'Samoan' },
      { value: 'gd', label: 'Scots Gaelic' },
      { value: 'sr', label: 'Serbian' },
      { value: 'st', label: 'Sesotho' },
      { value: 'sn', label: 'Shona' },
      { value: 'sd', label: 'Sindhi' },
      { value: 'si', label: 'Sinhala (Sinhalese)' },
      { value: 'sk', label: 'Slovak' },
      { value: 'sl', label: 'Slovenian' },
      { value: 'so', label: 'Somali' },
      { value: 'es', label: 'Spanish' },
      { value: 'su', label: 'Sundanese' },
      { value: 'sw', label: 'Swahili' },
      { value: 'sv', label: 'Swedish' },
      { value: 'tl', label: 'Tagalog (Filipino)' },
      { value: 'tg', label: 'Tajik' },
      { value: 'ta', label: 'Tamil' },
      { value: 'tt', label: 'Tatar' },
      { value: 'te', label: 'Telugu' },
      { value: 'th', label: 'Thai' },
      { value: 'tr', label: 'Turkish' },
      { value: 'tk', label: 'Turkmen' },
      { value: 'uk', label: 'Ukrainian' },
      { value: 'ur', label: 'Urdu' },
      { value: 'ug', label: 'Uyghur' },
      { value: 'uz', label: 'Uzbek' },
      { value: 'vi', label: 'Vietnamese' },
      { value: 'cy', label: 'Welsh' },
      { value: 'xh', label: 'Xhosa' },
      { value: 'yi', label: 'Yiddish' },
      { value: 'yo', label: 'Yoruba' },
      { value: 'zu', label: 'Zulu' },
    ];

    // Find the selected language label
    const selectedLanguageObj = languages.find(lang => lang.value === selectedLanguage);
    const selectedLanguageLabel = selectedLanguageObj ? selectedLanguageObj.label : 'English';

    return (
      <>
        <style>
          {`
            #goog-gt-tt {
              display: none !important;
            }
            .goog-te-gadget {
              color: transparent !important;
              font-size: 0px !important;
            }
            .goog-te-combo {
              opacity: 0; /* Hide visually but keep in DOM */
              width: 1px; /* Minimize footprint */
              height: 1px;
            }
            .goog-te-banner-frame {
              display: none !important;
            }
            body {
              top: 0px !important;
            }
            
            /* Responsive styles */
            .translatorIcon {
              position: relative;
              padding-top: 0px;
              display: flex;
              justify-content: flex-end;
            }
            
            .language-button {
              background-color: white;
              border: 1px solid #000;
              color: #000;
              font-size: 14px;
              height: 56px;
              border-radius: 10px;
              font-weight: bold;
              margin: 10px;
              display: flex;
              align-items: center;
              transition: all 0.3s ease;
            }
            
            .language-selector-modal .ant-modal-content {
              border-radius: 15px;
            }
            
            /* Prevent translation for language names */
            .notranslate {
              speak: none;
            }
            
            /* Media queries for responsiveness */
            @media (max-width: 768px) {
              .language-button {
                height: 48px;
                margin: 8px;
                padding: 0 10px;
              }
              
              .language-button-text {
                font-size: 12px;
              }
              
              .language-button-icon {
                width: 24px;
                height: 24px;
                margin-right: 3px;
              }
            }
            
            @media (max-width: 480px) {
              .language-button {
                height: 40px;
                margin: 5px;
                padding: 0 8px;
              }
              
              .language-button-text {
                font-size: 11px;
              }
              
              .language-button-icon {
                width: 20px;
                height: 20px;
                margin-right: 2px;
              }
              
              .language-selector-modal {
                max-width: 90vw !important;
                margin: 0 auto;
              }
            }
          `}
        </style>

        <div className="translatorIcon">
          <div style={{ display: 'none' }}>
            <div id="google_translate_element"></div>
          </div>

          <Button
            onClick={this.handleModalOpen}
            icon={<img 
              src={Language} 
              alt="Language" 
              className="language-button-icon"
              style={{ width: '30px', height: '30px', marginRight: 4 }} 
            />}
            className="language-button"
          >
            <span className="language-button-text" style={{fontSize:'14px', fontWeight:'bolder', color:'#00003B'}}>{selectedLanguageLabel}</span>
          </Button>

          <Modal
            title={<span style={{fontSize:'14px',color:'#00003B'}}>Select Language</span>}
            visible={modalVisible}
            onCancel={this.handleModalClose}
            footer={[
              <Button style={{ color:'red', borderColor:'red',backgroundColor:'#fce0e0', borderRadius:'25px' }} key="cancel" onClick={this.handleModalClose}>
                Cancel
              </Button>,
              <Button style={{ color:'#254edb', borderColor:'#254edb', backgroundColor:'#ebf4ff', borderRadius:'25px' }} key="save" type="primary" onClick={this.handleSave}>
                Save
              </Button>,
            ]}
            width="auto"
            style={{ maxWidth: '400px' }}
            closeIcon={<img src={CancelIcon} alt="Cancel" width="20px" height="20px" />}
            destroyOnClose={false}
            className="language-selector-modal"
          >
            <div style={{ padding: '20px 0' }}>
              {err ? (
                'There is some error'
              ) : (
                <Select
                  style={{ width: '100%', color:'#00003B' }}
                  placeholder="Select a language"
                  defaultValue={selectedLanguage}
                  value={tempSelectedLanguage}
                  onChange={this.handleLanguageChange}
                  options={languages}
                  showSearch
                  className="notranslate"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                />
              )}
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

export default GoogleTranslator;